import React from 'react';

function Element(props) {
    const {children, className, style, propRef,  anyprop, tag, htmlFor} = props;
    const CustomTag = `${tag}`;

    return <CustomTag style={style} className={className} ref={propRef} onClick={anyprop} htmlFor={htmlFor}>{children}</CustomTag>
 }
  
 export default Element;